/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ICreateSuburbanRealtyRequest {
  /** Строка с адресом **/
  address: string;
  /** Площадь участка **/
  landArea: number;
  /** Категория (участок/дом) **/
  category: ECategory;
  /** Состояние подписки на пуш **/
  isNeedPushSubscribe: boolean;
  /** Состояние подписки на чат **/
  isNeedChatSubscribe?: TCreateSuburbanRealtyRequest_IsNeedChatSubscribe;
  /** Площадь дома **/
  houseArea?: TCreateSuburbanRealtyRequest_HouseArea;
  /** Широта **/
  lat?: TCreateSuburbanRealtyRequest_Lat;
  /** Долгота **/
  lng?: TCreateSuburbanRealtyRequest_Lng;
  /** Точка входа из фронтенда для добавления объекта **/
  source?: TCreateSuburbanRealtyRequest_Source;
}

export enum ECategory {
  /** Загородный участок **/
  'LandSale' = 'landSale',
  /** Загородный дом **/
  'HouseSale' = 'houseSale',
}
export type TCreateSuburbanRealtyRequest_IsNeedChatSubscribe = null | boolean;

export type TCreateSuburbanRealtyRequest_HouseArea = null | number;

export type TCreateSuburbanRealtyRequest_Lat = null | number;

export type TCreateSuburbanRealtyRequest_Lng = null | number;

export type TCreateSuburbanRealtyRequest_Source = null | string;
